import { VIDEO_TYPE_ATTRIBUTE } from 'hb-react/backoffice/types/builder/itemAttributes/videoItemAttributes';

export const DYNAMIC_VIDEO_SELECTOR_OPTIONS = [
  { value: VIDEO_TYPE_ATTRIBUTE.UPLOADED_FILE, label: __('Upload') },
  { value: VIDEO_TYPE_ATTRIBUTE.LINK, label: __('Link') },
];
